module.exports = __webpack_public_path__ + "966739f5fa0b8112cf868fefd02209d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/chevron_2022_chart.png
// module id = 1651
// module chunks = 0